module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACsSURBVHgBlZLBDYMwEATXSQMu4Z55UoKfedJJSAVJB1EqSQlJB5RASuDJD85iEcLijLzSSJZvvT6dfYYtr1yVizIoPQpUK2PCRxEUqGIXUUHpiCDT8g22PAO+VrFlq49MSKBHrMNjJiTuvVhvMM/En1j8K3eu34rbCXA8CAZJahCmB9h60tNiHfBGcUCdVaSaXF2wPlfgXjRXKJBgHlD6keo9szsIWm7+wfjKE603Kc8GSeTCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/switch-icon-2.png
// module id = 350
// module chunks = 0